module.exports = __webpack_public_path__ + "img/slide_p8.be2b773b.png";